import React, { Component, Fragment } from "react";
import { Checkbox, Form } from "semantic-ui-react";
import _ from "lodash";
import config from "../../../config";
import { facetField, facetName, lookupTable } from "../../facet/rendering";

const FilterHeader = ({ children }) => (
  <span className="filter-header">{children}</span>
);

function gatherFacets(srchrslt_facets, section, facetType) {
  let gathered = {};
  for (const key in lookupTable[facetType]) {
    if (section.startsWith("him_") && !srchrslt_facets[key]) {
      continue;
    }

    if (config.FACETS && !config.FACETS[key] && !srchrslt_facets[key]) {
      continue;
    }

    gathered[key] = {
      key: key,
      value: facetName(facetType, key),
      count: srchrslt_facets[key] && `(${srchrslt_facets[key]})`,
      field: facetField(facetType, key)
    };
  }
  return gathered;
}

class Filter extends Component {
  onFilterAdd = (facetValue, fieldName) => {
    this.props.search.addFilter([
      {
        filterId: null,
        filterType: "O",
        fieldName: fieldName || this.props.facetType,
        facetType: this.props.facetType,
        fieldValue: facetValue
      }
    ]);
    this.props.triggerUpdate();
  };

  render() {
    const searchResults = this.props.search.getSectionResults(
      this.props.section
    );
    let srchrslt_facets = {};
    if (searchResults.facets && searchResults.facets[this.props.facetType]) {
      searchResults.facets[this.props.facetType].forEach(facet => {
        srchrslt_facets[facet.key] = facet.doc_count;
      });
    }
    if (
      this.props.section.startsWith("him_") &&
      Object.keys(srchrslt_facets).length < 2
    )
      return null;

    // The convoluted preparation adding items to 'gathered' is necessary to sort the facets by "value"
    let gathered = gatherFacets(
      srchrslt_facets,
      this.props.section,
      this.props.facetType
    );
    let facets = _.sortBy(gathered, [x => x.value]).map(obj => {
      const label =
        obj.count > 0 ? `${obj.value} (${obj.count})` : `${obj.value}`;

      const hasFilterEntry = this.props.search.hasFilterEntry(
        this.props.facetType,
        obj.key
      );

      const onClick = hasFilterEntry
        ? () => null
        : () => this.onFilterAdd(obj.key, obj.field);

      return (
        <Form.Field className="filter-field" key={obj.key}>
          <Checkbox
            label={label}
            checked={hasFilterEntry}
            disabled={hasFilterEntry}
            onClick={onClick}
          />
        </Form.Field>
      );
    });

    return facets.length > 0 ? (
      <Fragment>
        {this.props.header && <FilterHeader>{this.props.header}</FilterHeader>}
        {facets}
      </Fragment>
    ) : null;
  }
}

export default Filter;
